<template>
  <div class="d-empty">
    <!-- 图片部分 -->
    <div class="image-container">
      <img class="empty-image" src="../assets/noclass.png" alt="暂无数据" />
    </div>
    <!-- 文本部分 -->
    <div class="empty-text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DEmpty',
  props: {
    text: {
      type: String,
      default: '暂无数据', // 默认提示文本
    },
  },
};
</script>

<style scoped>
/* 容器样式 */
.d-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 图片容器 */
.image-container {
  display: flex;
  justify-content: center;
}

/* 图片样式 */
.empty-image {
  width: 88%;
  height: 270px;
  object-fit: contain; /* 保持图片比例 */
}

/* 文本样式 */
.empty-text {
  text-align: center;
  height: 100px;
  line-height: 100px; /* 垂直居中 */
  font-size: 16px;
  color: #666;
}
</style>